import { createWebHistory, createRouter } from "vue-router";
import appConfig from "../../app.config";
import routes from './route';
import store from '@/state/store'

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' | ' + appConfig.title;
  }
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.getters.loggedIn) {
      next({ name: 'default' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router;